
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import VueMeta from 'vue-meta';

Vue.use(VueMeta);

const namespace: string = 'restaurant';

@Component<AccessDenied>({
	metaInfo() {
		return {
			title: this.$t('profile.auth.access_denied.header'),
			meta: [
				{ charset: 'utf-8' },
				{ name: 'description', vmid: 'description', content: this.$t('profile.auth.access_denied.description') },
				{ name: 'viewport', content: 'width=device-width,initial-scale=1.0' },
				{ name: 'robots', content: 'noindex' },
				{ property: 'og:title', content: this.$t('profile.auth.access_denied.header') },
				{ property: 'og:description', content: this.$t('profile.auth.access_denied.description') },
				{ property: 'og:site_name', content: this.$t('profile.auth.access_denied.header') },
				{ property: 'og:type', content: 'website' }
			]
		};
	}
})
export default class AccessDenied extends Vue {
	@Getter('getRestaurant', { namespace }) private restaurant!: Restaurant;

	private get supportEmail(): string | null {
		return this.restaurant?.supportEmail || null;
	}
}
